import { errorHandler } from "../../utils/errorHandler";
import { APP_ERROR, APP_ERROR_CLEAR } from "./actions.types";

export const appError = (location, err, dispatch) => {
    dispatch({
        type: APP_ERROR,
        payload: {
            location,
            err: errorHandler(err)
        }
    })
}

export const appErrorClear = (dispatch) => {
    dispatch({
        type: APP_ERROR_CLEAR,
        payload: {
            location: null,
            err: null
        }
    })
}